import { ThemeColor } from '@qnpm/q-theme';
import { commonUtil, dateUtil } from '@qnpm/q-design-utils';
import holidayData from './holidayData.json';
// 导出日历数据
export const HolidayData = holidayData;
export default class HolidayUtil {
    constructor(sourceData) {
        this.sourceData = [];
        this.holidayData = {};
        this.sourceData = sourceData || holidayData;
        this.generatorHolidays();
    }
    /**
     * 返回节假日数据
     */
    getHolidayData() {
        return this.holidayData;
    }
    /**
     * 合并节假日数据
     * @param dataSource
     */
    mergeHolidayData(dataSource) {
        // 如果没有dataSource，则直接返回节假日数据
        if (!dataSource || !commonUtil.isValidObject(dataSource)) {
            return this.holidayData;
        }
        const nextDataSource = Object.assign({}, dataSource);
        Object.keys(this.holidayData).forEach((dateStr) => {
            const currentSource = nextDataSource[dateStr];
            const currentHoliday = this.holidayData[dateStr];
            // 如果当前节假日存在于配置中，则进行Merge
            if (currentSource) {
                nextDataSource[dateStr] = Object.assign(Object.assign({}, currentSource), { header: Object.assign(Object.assign({}, currentHoliday.header), currentSource.header), content: Object.assign(Object.assign({}, currentHoliday.content), currentSource.content) });
            }
            else {
                // 如果节假日不存在于日历配置中，则直接设置节假日数据
                nextDataSource[dateStr] = currentHoliday;
            }
        });
        return nextDataSource;
    }
    /**
     * 生成节假日数据
     */
    generatorHolidays() {
        this.sourceData.forEach((item) => this.convertItem(item));
    }
    /**
     * 转换每个节假日为具体日期数据
     * @param item
     */
    convertItem(item) {
        const { duration, date, workdays, willRest, main, title } = item;
        // 生成节假日范围
        const rangeDate = this.generatorRangeDate(date, duration);
        // 填充节假日信息
        this.fillVacationDays(rangeDate, title, main, willRest);
        // 填充补班信息
        this.fillWorkDays(workdays);
    }
    /**
     * 填充补班信息
     * @param workdays
     */
    fillWorkDays(workdays) {
        commonUtil.isValidArray(workdays) &&
            workdays.forEach((dateStr) => {
                this.fillDayItem(dateStr, '班', ThemeColor.text1, ThemeColor.text1);
            });
    }
    /**
     * 填充节假日信息
     * @param rangeDate
     * @param title
     * @param main
     * @param willRest
     */
    fillVacationDays(rangeDate, title, main, willRest) {
        commonUtil.isValidArray(rangeDate) &&
            rangeDate.forEach((dateStr) => {
                const text = main === dateStr ? title : willRest ? '休' : '';
                const color = willRest ? ThemeColor.price : ThemeColor.text1;
                this.fillDayItem(dateStr, text, color, color);
            });
    }
    /**
     * 将节假日数据填入最终集合
     * @param dateStr
     * @param headerText
     * @param headerColor
     * @param contentColor
     */
    fillDayItem(dateStr, headerText, headerColor, contentColor) {
        // 如果没有日期的什么都不做
        if (!dateStr) {
            return;
        }
        const prevValue = this.holidayData[dateStr];
        // 如果不同节假日出现在相同日期，不改变颜色，只改变头部展示文案
        if (prevValue) {
            this.holidayData[dateStr] = Object.assign(Object.assign({}, prevValue), { header: Object.assign(Object.assign({}, prevValue.header), { text: headerText }) });
        }
        else {
            this.holidayData[dateStr] = {
                header: {
                    text: headerText,
                    color: headerColor
                },
                content: {
                    color: contentColor
                }
            };
        }
    }
    /**
     * 计算范围日期
     * @param startDate
     * @param duration
     */
    generatorRangeDate(startDate, duration) {
        const dateRange = [];
        for (let i = 0; i < duration; i++) {
            const dateStr = dateUtil.appendDate(startDate, { date: i }, { format: true });
            dateRange.push(dateStr);
        }
        return dateRange;
    }
}
